import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-account-filter',
  templateUrl: './common-account-filter.component.html',
  styleUrls: ['./common-account-filter.component.css']
})
export class CommonAccountFilterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
